import {getLidarFileNames} from "../../getLidarFileNames";

function convertDate(dateStr) {
  const monthMap = {
    'JAN': '01', 'FEB': '02', 'MAR': '03', 'APR': '04',
    'MAY': '05', 'JUN': '06', 'JUL': '07', 'AUG': '08',
    'SEP': '09', 'OCT': '10', 'NOV': '11', 'DEC': '12'
  };

  const [year, monthAbbr, day] = dateStr.split('-');
  return `${monthMap[monthAbbr]}/${day}/${year}`;
}

export const arlington_paths_2025 = async (accessToken) =>  {
  try {
    const main_path = 'processed-lidar-data/arlington_tx_processed/';
    const raw_lidar_paths = await getLidarFileNames(main_path, accessToken)
    const lidar_paths = raw_lidar_paths.data.map(item => item.replace(main_path, '').replace('/', ''));
  return lidar_paths.map((path) => {
  const date = convertDate(path.split('_')[0].split('-').slice(1, 4).join('-'));
  return {
    url: `${process.env.REACT_APP_LIDAR_CDN_URL}/arlington_tx_processed/${path}`,
    name: `Arlington TX - ${path}`,
    description: `Scan of Arlington TX 2025 data`,
    date_uploaded: new Date(date),
    data_identifier: 'arlington_tx',
    collector: 'arlington_collector',
    projection: "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000 +datum=NAD83 +units=us-ft +no_defs +type=crs",
  }})
  } catch (error) {
    console.error('Error fetching Arlington TX lidar paths:', error);
    return [];
  }
 
};

